import {getEventData} from "../../api/eventController";


export const fetchEventDataByName = async ({
                                            eventName,
                                            setEventData,
                                            setStatusInProgress,
                                            setStatusSuccess,
                                            setStatusFailed,
                                            setStatusError,
                                        }) => {
    setStatusInProgress();
    try {
        let response = await getEventData(eventName);

        if (!!response?.success) {
            const eventData = response.data;

            if (!eventData?.length) {
                setStatusFailed();
                return;
            }

            // eventName is a substring match, so multiple years' events can come back (e.g. "Trade Show
            // 2025" and "Trade Show 2026" both match "Trade Show") — the one with the latest startDate is
            // the current/upcoming show, regardless of which was created in the database first.
            const latestEvent = [...eventData].sort(
                (a, b) => new Date(b.startDate) - new Date(a.startDate),
            )[0];

            setEventData(latestEvent);
            setStatusSuccess();
        }
        else {
            setStatusFailed();
        }
    }
    catch (error) {
        console.error(error);
        setStatusError();
    }
};